import { format, parse } from 'date-fns';
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';

const ZURICH_TZ = 'Europe/Zurich';

export const getToday = () => {
  return toZonedTime(new Date(), ZURICH_TZ);
};

export const getFormattedDateForApi = (date: string | Date) => {
  if (typeof date === 'string') {
    const parsedVisualDate = parse(date, 'dd MMM yyyy', new Date());

    return format(parsedVisualDate, 'yyyy-MM-dd');
  }

  return formatInTimeZone(date, ZURICH_TZ, 'yyyy-MM-dd');
};
